export const desktopNotify = async(notificationInfo) => {
  if (window.Notification.permission !== 'granted') {
    console.warn('NO PERMISSION FOR NOTIFICATION', window.Notification.permission);
    await window?.Notification?.requestPermission();
  }
  console.log('notification from iframe', notificationInfo);
  const { title, body, disappearAfter, imageURL } = notificationInfo;
  const options = {
    body,
    tag: title + body,
  };
  if (imageURL) {
    options.icon = imageURL;
    options.image = imageURL;
  }
  const notification = new Notification(title, options);
  notification.onclick = () => {
    window.focus();
    notification?.close();
  };

  if (disappearAfter) {
    setTimeout(() => notification?.close(), disappearAfter);
  }
};
